const enforceMaxValue = (input) => {
    const max = parseInt(input.max, 10); // Get the max value from the attribute
    input.value = input.value.replace(/^0$/, '').replace(/[eE]/g, '');
    if (parseInt(input.value, 10) > max) {
      input.value = max; // Reset the value to the max if exceeded
    }
}

document.getElementById('add-to-cart').addEventListener('click', function (event) {
  event.preventDefault();

  // Select all quantity input fields
  const quantities = document.querySelectorAll('.variant-quantity');
  const items = [];

  quantities.forEach(input => {
    const quantity = parseInt(input.value);
    const variantId = input.getAttribute('data-variant-id');

    // Validate that the quantity is a positive number and a valid variant ID exists
    if (!isNaN(quantity) && quantity > 0 && variantId) {
      items.push({
        id: parseInt(variantId), // Ensure the variant ID is a valid number
        quantity: quantity
      });
    }
  });

  if (items.length > 0) {
    // Send the valid items to the Shopify AJAX API
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items: items })
    })
      .then(response => {
        if (!response.ok) {
          throw new Error(`Error adding to cart: ${response.statusText}`);
        }
        return response.json();
      })
      .then(data => {
        window.location.href = '/cart'; // Redirect to the cart page
      })
      .catch(error => {
        console.error('Add to cart error:', error);
        alert('An error occurred while adding items to the cart. Please try again.');
      });
  } else {
    alert('Please enter a valid quantity for at least one item.');
  }
});